import gql from 'graphql-tag';

export const GET_NEW_DAMAGE_REQUEST_URL = gql`
  query CurrentPartner {
    currentPartner {
      damageRequestIframeUrl
    }
  }
`;
